import { Component, inject } from '@angular/core';
import { StopRequestorService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  StopRequestorCreateDto,
  StopRequestorDto,
  StopRequestorExcelDownloadDto,
  StopRequestorUpdateDto,
} from '../proxy/controlling/dtos/stop-requestor';
import { STOPREQUESTOR_CONFIG, STOPREQUESTOR_FIELDS } from './stop-requestor.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-stop-requestor',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, StopRequestorService, ConfirmationService],
  templateUrl: './stop-requestor.html',
  styleUrl: './stop-requestor.scss',
})
export class StopRequestor extends BaseCrudComponent<
  StopRequestorDto,
  StopRequestorCreateDto,
  StopRequestorUpdateDto,
  StopRequestorExcelDownloadDto
> {
  service = inject(StopRequestorService);
  config = STOPREQUESTOR_CONFIG;
  fields = STOPREQUESTOR_FIELDS;

  protected prepareUpdateDto(data: any, selected: StopRequestorDto): StopRequestorUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'StopRequestor';
  }
}
